export { default as DefaultLogoIcon } from '@/assets/graphics/logoIcons/default/logoIcon.svg';
